import { Component } from "react";
import Link from "admin/shared/ui/Link.Component";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// custom markup
import RetractableSidebar, {
  activeStyle,
} from "../../../home/components/Retractable.Sidebar";

// icons
import SystemBrowserIcon from "@material-ui/icons/Computer";
import AutoInvestIcon from "@material-ui/icons/Memory";
import TermsIcon from "@material-ui/icons/FormatListNumberedRtl";
import TemplatesIcon from "@material-ui/icons/Drafts";
import SettingsIcon from "@material-ui/icons/Settings";

class SettingsComponent extends Component {
  render() {
    let wrapperStyle = {
      display: "flex",
      minHeight: "100%",
    };

    return (
      <div style={wrapperStyle}>
        <RetractableSidebar storageKey="settings">
          <List>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"autoinvest"}
            >
              <ListItem button>
                <ListItemIcon>
                  <AutoInvestIcon />
                </ListItemIcon>
                <ListItemText primary="Autoinvest settings" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"browser"}
            >
              <ListItem button>
                <ListItemIcon>
                  <SystemBrowserIcon />
                </ListItemIcon>
                <ListItemText primary="System browser" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"terms"}
            >
              <ListItem button>
                <ListItemIcon>
                  <TermsIcon />
                </ListItemIcon>
                <ListItemText primary="Terms" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"templates"}
            >
              <ListItem button>
                <ListItemIcon>
                  <TemplatesIcon />
                </ListItemIcon>
                <ListItemText primary="Templates" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"settings"}
            >
              <ListItem button>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItem>
            </Link>
          </List>
        </RetractableSidebar>
        <div
          style={{
            //padding: '20px',
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default SettingsComponent;
